import React from 'react';

import { useHistory, useParams } from 'react-router';

import AppBar from '@material-ui/core/AppBar';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';

import { BulkAccountStatusChanger } from './pending-admin-action-tabs/bulk-account-status-changer';
import { FailedTwilioRegistrations } from './pending-admin-action-tabs/failed-twilio-registrations';
import { IncompleteEmployeeDirectoryImports } from './pending-admin-action-tabs/incomplete-employee-directory-imports';
import { UnlinkedCraigslistAdBoosts } from './pending-admin-action-tabs/unlinked-craigslist-ad-boosts';

import { UiIconTabLabel } from '../../ui/ui-icon-tab';

import { ACCOUNT_STATUS } from '../../util/account-status';
import { PENDING_ADMIN_ACTION } from '../util/admin-web-routes';

type PendingAdminTabConfig = {
  index: number;
  path: string;
  title: string;
  Component: React.FunctionComponent;
  queryParams?: object;
};

type PendingActionTabKey =
  | 'incomplete-employee-directory-import'
  | 'unlinked-craigslist-ads'
  | 'bulk-account-status-changer'
  | 'failed-twilio-registrations';

export const PENDING_ACTION_TAB_CONFIG: { [key in PendingActionTabKey]: PendingAdminTabConfig } = {
  'incomplete-employee-directory-import': {
    index: 0,
    path: 'incomplete-employee-directory-import',
    title: 'Employee list Imports',
    Component: IncompleteEmployeeDirectoryImports,
  },
  'unlinked-craigslist-ads': {
    index: 1,
    path: 'unlinked-craigslist-ads',
    title: 'Craigslist Ads',
    Component: UnlinkedCraigslistAdBoosts,
  },
  'bulk-account-status-changer': {
    index: 2,
    path: 'bulk-account-status-changer',
    queryParams: {
      accountStatus: [ACCOUNT_STATUS.PRE_TRIAL, ACCOUNT_STATUS.TRIAL_LAPSED],
    },
    title: 'Bulk Account Status Changer',
    Component: BulkAccountStatusChanger,
  },
  'failed-twilio-registrations': {
    index: 3,
    path: 'failed-twilio-registrations',
    title: 'Failed Twilio Registrations',
    Component: FailedTwilioRegistrations,
  },
};

const isValidPendingAdminTabKey = (val?: string): val is PendingActionTabKey =>
  Boolean(val && Boolean(PENDING_ACTION_TAB_CONFIG[val as keyof typeof PENDING_ACTION_TAB_CONFIG]));

const PendingAdminAction = () => {
  const { pendingAdminTab } = useParams<{ pendingAdminTab?: string }>();
  let tabConfig = PENDING_ACTION_TAB_CONFIG['incomplete-employee-directory-import'];
  if (isValidPendingAdminTabKey(pendingAdminTab)) {
    tabConfig = PENDING_ACTION_TAB_CONFIG[pendingAdminTab];
  }
  const history = useHistory();

  const CurrentTab = tabConfig.Component;

  const handleTabChange = (_e: React.ChangeEvent<{}>, selectedTab: number) => {
    const newConfig = Object.values(PENDING_ACTION_TAB_CONFIG).find(
      (tc) => tc.index === selectedTab,
    );
    if (newConfig) {
      history.push(PENDING_ADMIN_ACTION(newConfig.path, newConfig.queryParams));
    }
  };

  const sortedTabTitles = Object.values(PENDING_ACTION_TAB_CONFIG).map((tc) => (
    <Tab key={`pending-admin-tab-title-${tc.index}`} label={<UiIconTabLabel label={tc.title} />} />
  ));

  return (
    <div>
      <AppBar position="static">
        <Tabs value={tabConfig.index} onChange={handleTabChange}>
          {sortedTabTitles}
        </Tabs>
      </AppBar>
      <div className="card card-body">{CurrentTab && <CurrentTab />}</div>
    </div>
  );
};

// This needs to be exported as default, so it can be lazily imported by app
export default PendingAdminAction;
